import React from "react";
import Container from "@/components/marketing/Container";
import { Link } from "react-router-dom";
import SectionHeading from "@/components/marketing/SectionHeading";

const WHY_CARDS = [
  { title: "One platform", desc: "Earned, newswire, and guaranteed in a single place." },
  { title: "No agencies", desc: "Buy the channels directly. No retainers, no middle layer." },
  { title: "No lock-ins", desc: "Pay per release. Combine channels only when you want to." },
  { title: "Transparent pricing", desc: "See what each channel costs before you commit." },
];

export default function WhyDigital24() {
  return (
    <section className="bg-canvas py-11 lg:py-[72px]">
      <Container>
        <SectionHeading
          tag="WHY DIGITAL24"
          title="Built so you can act with confidence"
          subtitle="Whichever channel you choose, the platform works the same way."
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
          {WHY_CARDS.map((c) => (
            <div key={c.title} className="glass-card p-6">
              <h3 className="text-[#14121c] text-[15px] font-semibold mb-2">{c.title}</h3>
              <p className="text-[#3a3646] text-sm leading-[1.6]">{c.desc}</p>
            </div>
          ))}
        </div>

        {/* Packages bridge */}
        <div className="glass-card p-6 sm:p-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6">
          <div className="max-w-2xl">
            <h3 className="text-[#14121c] text-xl sm:text-2xl font-semibold mb-2">Prefer a ready-made combination?</h3>
            <p className="text-[#3a3646] text-[15px] leading-[1.6]">
              Our curated packages bundle the channels that work best together for common goals: one purchase, defined outcomes, transparent pricing.
            </p>
          </div>
          <Link
            to="/packages"
            className="inline-flex items-center justify-center shrink-0 bg-brand-gradient hover:opacity-90 text-white font-semibold px-6 py-[13px] rounded-[14px] text-[14px] transition-opacity whitespace-nowrap"
            style={{ boxShadow: "0 8px 20px rgba(124,58,237,0.35)" }}
          >
            Explore Packages →
          </Link>
        </div>
      </Container>
    </section>
  );
}